import "ngstorage";
import "ngmap";

class JobdetailsController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    EventsService,
    ProfileService,
    SecurityService,
    $stateParams,
    $timeout,
    NgMap,
    $rootScope,
    $scope,
    JobService,
    $location,
    $window,
    TrackingService,
    IterableService,
    analytics
  ) {
    this.name = "jobdetails";
    $localStorage.activeStateName = "jobdetails";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$profile = ProfileService;
    this.$events = EventsService;
    this.$window = $window;
    this.$location = $location;
    this.$tracking = TrackingService;
    this.$iterable = IterableService;
    this.$jobs = JobService;
    this.$security = SecurityService;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$analytics = analytics;
    this.currentUser = this.$auth.getUserData();
    this.ad_origin = this.$location.$$search.src;
    this.delivery = false;

    const jobble_id = this.$stateParams.jobId;

    const source = this.$location.$$search.utm_source || this.$location.$$search.ondmd_jsrc || this.$location.$$search.jsrc;
    const campaign = this.$location.$$search.utm_campaign || this.$location.$$search.ondmd_jcam || this.$location.$$search.jcam;

    this.$location.path("/jobs").search({
      rjid: jobble_id,
      o: this.$location.$$search.o ? 1 : undefined,
      utm_source: source || undefined,
      utm_campaign: campaign || undefined,
    });
  }
}

JobdetailsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "profile",
  "security",
  "$stateParams",
  "$timeout",
  "NgMap",
  "$rootScope",
  "$scope",
  "jobs",
  "$location",
  "$window",
  "tracking",
  "iterable",
  "analytics",
];

export default JobdetailsController;



// WEBPACK FOOTER //
// ./client/app/components/jobdetails/jobdetails.controller.js